import { FC } from 'react';
import { withStyles } from '../../../utils';
import styles from './RadioButtonIndicator.module.scss';

const cn = withStyles(styles);

type RadioButtonIndicatorProps = {
  checked: boolean;
};

/**
 * Visual-only; has no interactivity on its own.
 *
 * Put an `input[type="radio"]` AFTER it if you want it to be a radio button:
 * ```tsx
 * <label>
 *   <RadioButtonIndicator checked={checked} />
 *   <input type="radio" name="group" onChange={selectThis} />
 * </label>
 * ```
 *
 * Wrap it in a button if you want it to be a button:
 * ```tsx
 * <button onClick={selectThis}>
 *   <RadioButtonIndicator checked={checked} />
 * </button>
 * ```
 *
 * Or it can just be a visual representation of some other thing being activated:
 * ```tsx
 * <button onClick={selectThis}>Select It</button>
 * ...
 * <RadioButtonIndicator checked={checked} />
 * ```
 */
const RadioButtonIndicator: FC<RadioButtonIndicatorProps> = ({ checked }) => {
  return <div className={cn('radioIndicatorContainer', checked && 'checked')} />;
};

export default RadioButtonIndicator;
